import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'
import checkPageFeaturesGuard from '@/router/guards/check-page-features-guard'
import checkAddPageGuard from '@/router/guards/check-add-page-guard'

export default [
  {
    path: '/instagram',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard, checkAddPageGuard, checkPageFeaturesGuard]),
    children: [
      {
        path: 'posts',
        name: 'owner:instagram-posts',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/account/posts.vue'),
      },
      {
        path: 'reports',
        name: 'owner:instagram-reports',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/ReportsTable.vue'),
      },
      {
        path: 'reply/:id',
        name: 'owner:instagram-reply',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/AddReply.vue'),
      },
      {
        path: 'reply/:id/edit',
        name: 'owner:instagram-reply-edit',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/EditReply.vue'),
      },
      {
        path: 'templates',
        name: 'owner:instagram-reply-templates',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/ReplyTemplatesTable.vue'),
      },
      {
        path: 'replies/add-template',
        name: 'owner:instagram-reply-template',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/reply-template/AddReplyTemplate.vue'),
      },
      {
        path: 'replies/edit-template/:id',
        name: 'owner:instagram-reply-template-edit',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/reply-template/EditReplyTemplate.vue'),
      },
      {
        path: 'hashtag/search',
        name: 'owner:instagram-hashtag-search',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/hashtag/search.vue'),
      },
      {
        path: 'published-posts',
        name: 'owner:insta-published-posts',
        component: () => import(/* webpackChunkName: "instagram-poster" */ '@/views/owner-instagram/poster/PublishedPostsPage.vue'),
      },
      {
        path: 'scheduled-posts',
        name: 'owner:insta-scheduled-posts',
        component: () => import(/* webpackChunkName: "instagram-poster" */ '@/views/owner-instagram/poster/ScheduledPostsPage.vue'),
      },
      {
        path: 'poster/:id?',
        name: 'owner:insta-poster',
        component: () => import(/* webpackChunkName: "instagram-poster" */ '@/views/owner-instagram/poster/AddPostPage.vue'),
      },
      {
        path: 'quick-reply/story-mention',
        name: 'owner:instagram-story-mention',
        component: () => import(/* webpackChunkName: "instagram-bot" */ '@/views/owner-instagram/bot/StoryMentionReply.vue'),
      },
      {
        path: 'quick-reply/story-reply',
        name: 'owner:instagram-story-reply',
        component: () => import(/* webpackChunkName: "instagram-bot" */ '@/views/owner-instagram/bot/StoryCommentReply.vue'),
      },
      {
        path: 'instagram-stories',
        name: 'owner:instagram-stories',
        component: () => import(/* webpackChunkName: "instagram-bot" */ '@/views/owner-instagram/account/stories.vue'),
      },
      {
        path: 'stories-reply/:id',
        name: 'owner:instagram-stories-reply',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/AddStoryReply.vue'),
      },
      {
        path: 'stories-reply/:id/edit',
        name: 'owner:instagram-stories-reply-edit',
        component: () => import(/* webpackChunkName: "instagram" */ '@/views/owner-instagram/reply/EditStoryReply.vue'),
      },
      {
        path: 'chat',
        name: 'owner:instagram-chat',
        meta: {
          contentRenderer: 'sidebar-left',
          contentClass: 'chat-application',
        },
        component: () => import(/* webpackChunkName: "instagram-chat" */ '@/views/chat/Chat.vue'),
      },
    ],
  },
]
